import angular from 'angular';

import '../../services/product';
import '../../services/media';

angular.module('folkeuni').component('productsRelated', {
  transclude: true,
  templateUrl: '/shop-dist/templates/products-related.html?c=' + window.cacheBurst,
  bindings: {
    currentProgramUrl: '@',
    productIds: '@',
    siteId: '@'
  },
  controller: function (Media, Product, $timeout) {
    var $ctrl = this;
    $ctrl.productsRelated = [];

    $ctrl.$onInit = function () {

      var currentProductIds = $ctrl.productIds.split(',');
      var validatedProductIds = [];

      for (var i = 0; i < currentProductIds.length; i++) {
        var currentProductId = currentProductIds[i];
        if (!isNaN(parseInt(currentProductId))) {
          validatedProductIds.push(currentProductId);
        }
      }

      Product.getProductsById($ctrl.siteId, validatedProductIds).then(function (productArray) {
        $ctrl.productsRelated = productArray;

        if ($ctrl.productsRelated.length > 0) {
          $timeout(function () {
            var queryString = "id:";
            
            for (var i = 0; i < $ctrl.productsRelated.length; i++) {
              var currentProduct = $ctrl.productsRelated[i];
    
              if (i > 0) { queryString += " OR "; }
              queryString += currentProduct.imageId;
            }         
    
            var imageSearchQuery = { query: queryString, take: 1000 };


            Media.searchImages(imageSearchQuery).then(function (imgResponse) {
              for (var i in $ctrl.productsRelated) {
                var currentProduct = $ctrl.productsRelated[i];

                for (var y in imgResponse) {
                  var currentImage = imgResponse[y];
                  if (typeof currentImage !== "undefined" && currentImage != null) {
                    if (currentImage.id == currentProduct.imageId) {
                      currentProduct.imageObj = currentImage;

                      $ctrl.productsRelated[i].productImageUrl = Media.buildCropUrl(currentImage,'1:1(Small)');          
                    }
                  }
                }
              }          
            });
          }, 10);
        }

      }, function (errorResponse) {
        console.log("Error", errorResponse);
      });
    }
  }
});
